<script lang="ts">
export default {
    name: 'FiltersAction',
    props: {
        loading: { type: Boolean, required: false },
    },
    emits: ['resetFilters', 'resetPagination', 'loadData'],
    data() {
        return {}
    },
}
</script>

<template>
    <v-row
        no-gutters
        justify="end"
    >
        <v-col
            cols="12"
            sm="6"
            lg="3"
            class="pa-2"
        >
            <v-btn
                :loading="loading"
                color="secondary"
                block
                @click="$emit('resetFilters')"
            >
                <p style="white-space: normal;">
                    Réinitialiser les filtres
                </p>
            </v-btn>
        </v-col>
        <v-col
            cols="12"
            sm="6"
            lg="3"
            class="pa-2"
        >
            <v-btn
                :loading="loading"
                color="primary"
                block
                type="submit"
                @click.prevent="$emit('resetPagination'); $emit('loadData');"
            >
                <p style="white-space: normal;">
                    Lancer la recherche
                </p>
            </v-btn>
        </v-col>
    </v-row>
</template>
